var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgKitIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 58,
    height: 74
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "kit-icon_svg__a",
    d: "M3.659 0H50.62a3.66 3.66 0 013.66 3.659v63.15a3.66 3.66 0 01-3.66 3.66H3.66A3.661 3.661 0 010 66.808V3.66A3.66 3.66 0 013.659 0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(2 2)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "kit-icon_svg__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#kit-icon_svg__a"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#kit-icon_svg__b)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-45 71.262 57.15)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 41.317,
    height: 60.86,
    x: 0.496,
    y: 0.034,
    fill: "#545AA3",
    rx: 18.863
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFEC82",
    d: "M86.08 39.183v2.848c0 10.417-8.445 18.863-18.863 18.863H19.36C8.94 60.894.496 52.448.496 42.03v-2.848c0-10.417 8.445-18.863 18.863-18.863h47.858c10.418 0 18.863 8.446 18.863 18.863z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F7D330",
    d: "M41.812 20.32v21.71c0 10.418-8.445 18.864-18.862 18.864h-3.591C8.94 60.894.496 52.448.496 42.03v-2.848c0-10.417 8.445-18.863 18.863-18.863h22.453z"
  }))), /*#__PURE__*/React.createElement("g", {
    stroke: "#0F0238",
    strokeWidth: 2.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.659 0H50.62a3.66 3.66 0 013.66 3.659v63.15a3.66 3.66 0 01-3.66 3.66H3.66A3.661 3.661 0 010 66.808V3.66A3.66 3.66 0 013.659 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.53 19.9h6.75v31.636h-6.75a3.66 3.66 0 01-3.66-3.659V23.558a3.66 3.66 0 013.66-3.659z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.218 14.984h17.416m-17.416 7.909h13.427m-13.427 7.909h17.416",
    strokeLinecap: "round"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M-86-26h231V93H-86z"
  }))));
}

export default SvgKitIcon;